import { ApiUrl } from '@common/enums';
import { StoreModel } from '@common/models/store.model';
import { StoresQueryParams } from '@ee-api/queryParams';

import { easyEstimatorApi } from '../easyEstimatorService';

const storesApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchStores: builder.query<StoreModel[], StoresQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.STORES,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchStoresQuery, useLazyFetchStoresQuery } = storesApi;
